import React from 'react';
import PagePanel from './PagePanel';
import Link from './Link';

const HomePage = props => (
  <PagePanel>
    <p>Welcome to the Accounting Case Template, a tool that allows you to quickly create a detailed case assignment for your students in introductory financial accounting. By selecting various options, you tailor the case assignment to suit your own preferences.</p>

    <h3>Summary</h3>
    <p>The basic case assignment is to have groups of students compare two or more companies in the same industry, using the Form 10-K for each company as the data sources for the case.</p>
    <p>The Accounting Case Template allows you to customize the assignment by choosing specific topics to be covered, how many students per group, whether you want the students to make an oral presentation, whether students should hand in a written paper, how the written assignment should be submitted to you, and many other options.</p>
    <p>After you have made your case option selections, you will be able to download a Word document. You can then edit the document if you wish, or use it as generated.</p>

   <h3>Learning objectives</h3>
    <p>After completing the accounting case assignment, students will be able to:</p>
    <ol>
      <li>Describe an industry in which two or more companies operate</li>
      <li>Locate a Form 10-K for a company</li>
      <li>Identify GAAP accounting principles that a company is using</li>
      <li>Compare two or more companies’ selection of GAAP principles</li>
      <li>Evaluate two or more companies using financial ratios</li>
      <li>Prepare a written report <i>(Optional, depending on instructor choice)</i></li>
      <li>Present an analysis of the case <i>(Optional, depending on instructor choice)</i></li>
    </ol>
    <p>To start using the Accounting Case Template, <Link href="/casetemplate">click here</Link>.</p>
    
    <h3>Resources</h3>
    <p>This website also includes my teaching notes, which is a compilation of notes I have created from my use of this case assignment in both an undergraduate introductory financial accounting class and an MBA financial accounting class (see <Link href="/teachingnotes">Teaching Notes</Link>.)</p>
    <p>You can also request an Excel Check Figures worksheet from me that will allow you to enter some data from a Form 10-K to provide check figures when grading student assignments (see <Link href="/checkfigures">Excel Check Figures</Link>.)</p>
  </PagePanel>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js